import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { MainText, SecondText } from '../../style'
import { RapidMovementOfFundsProps } from './RapidMovementOfFundsProps'

export const RapidMovementOfFunds: FC<RapidMovementOfFundsProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <MainText>Rapid movement of funds, such as cash deposits followed by immediate cash withdrawals.</MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SecondText>
          Review Quarterly Analytics for cash withdrawals. If withdrawals are found, check the date for immediate cash
          deposits prior to the withdrawal.
        </SecondText>
      </Col>
      <Col>
        <Field
          name="reviewTransactionActivityRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTransactionActivityImmediateDeposits"
          label="Were there immediate deposits before cash withdraws? If so, what type?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'No Transactions of this Type',
                value: 'no_transactions'
              },
              {
                label: 'Change orders',
                value: 'change_orders'
              },
              {
                label: 'Product purchases',
                value: 'product_purchases'
              },
              {
                label: 'Other - See Comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTransactionActivityComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
